import React from 'react';

const OpenInNewIcon = ({ width = 24, height = 24, color = 'currentColor', ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
  </svg>
);

export default OpenInNewIcon;
